"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumberArray = void 0;
const is_array_of_type_1 = require("./is-array-of-type");
exports.isNumberArray = (value) => is_array_of_type_1.isArrayOfType(value, "number");
//# sourceMappingURL=is-number-array.js.map